import * as Types from './types';
import { actionTypes } from './constants';

export const setLangAction = (lang: string): Types.ISetLangActionAction => ({
    type: actionTypes.SET_LANG,
    payload: lang
});

// eslint-disable-next-line max-len
export const setUserTagsAction = (userTags: Types.IPlayerTag): { payload: Types.IPlayerTag; type: actionTypes.SET_USER_TAGS } => ({
    type: actionTypes.SET_USER_TAGS,
    payload: userTags
});

export const setLegacyUserDataAction = (data: Types.IUserLegacyData): Types.ISetLegacyUserDataAction => ({
    type: actionTypes.SET_LEGACY_USER_DATA,
    payload: data
});

export const setClientIP = (clientIp: string): Types.ISetClientIPAction => ({
    type: actionTypes.SET_CLIENT_IP,
    payload: clientIp
});

export const setIsAlive = (isAlive: boolean): Types.ISetIsAliveAction => ({
    type: actionTypes.SET_IS_ALIVE,
    payload: isAlive
});

export const setCountry = (country: string): Types.ISetCountryAction => ({
    type: actionTypes.SET_COUNTRY,
    payload: country
});

export const setCountryByGeoIP = (country: string): Types.ISetCountryByGeoIPAction => ({
    type: actionTypes.SET_COUNTRY_BY_GEO_IP,
    payload: country
});

export const setGeoData = (geoData: Types.IGeoData): Types.ISetGeoDataAction => ({
    type: actionTypes.SET_GEO_DATA,
    payload: geoData
});

export const userSetAttributesAction = (data: Partial<Types.IUserState>): Types.IUserSetAttributesAction => ({
    type: actionTypes.SET_ATTRIBUTES,
    payload: data
});

export const userUnsetAttributesAction = (attr: keyof Types.IUserState): Types.IUserUnsetAttributesAction => ({
    type: actionTypes.UNSET_ATTRIBUTE,
    payload: attr
});

export const resetToDefault = (): Types.IResetToDefaultAction => ({
    type: actionTypes.RESET_TO_DEFAULT
});

export const setDetails = (data: Partial<Types.IUserDetails>): Types.ISetDetailsAction => ({
    type: actionTypes.SET_DETAILS,
    payload: data
});

export const setCurrencyCode = (currency: string): Types.ISetCurrencyCodeAction => ({
    type: actionTypes.SET_CURRENCY_CODE,
    payload: currency
});

export const toggleBalance = (isHidden: boolean): Types.IToggleBalanceAction => ({
    type: actionTypes.TOGGLE_BALANCE,
    payload: isHidden
});
